import { ClipboardCheck, ClipboardCopy } from "lucide-react";
import { type PropsWithChildren, useEffect, useState } from "react";
import { cn } from "@/utils/cn";

interface CopyBtnProps extends PropsWithChildren {
	value: string;
	className?: string;
}

function copyToClipboard(value: string) {
	void navigator.clipboard.writeText(value);
}

export default function CopyBtn({ children, value, className }: CopyBtnProps) {
	const [hasCopied, setHasCopied] = useState(false);

	useEffect(() => {
		setTimeout(() => {
			setHasCopied(false);
		}, 2000);
	}, [hasCopied]);

	return (
		<div
			className={cn(
				"relative w-fit rounded px-1",
				"flex flex-row items-center group gap-1",
				"border box-border border-transparent",
				"cursor-pointer hover:border-gray-200  hover:bg-white",
				className,
			)}
			onClick={() => {
				copyToClipboard(value);
				setHasCopied(true);
			}}
		>
			{children}
			<div className={"hidden group-hover:block"}>
				{hasCopied ? (
					<ClipboardCheck className={"h-4 w-4 text-green-500"} />
				) : (
					<ClipboardCopy className={"h-4 w-4 text-slate-600"} />
				)}
			</div>
		</div>
	);
}
